import { UseSnippetsResponse } from '../../../hooks/useSnippets';

export const getHasSnippets = (snippets: UseSnippetsResponse['results']): boolean =>
  snippets.length > 0;
